(() => {
  'use strict';
  if (customElements.get('sbc-quick-add')) return;
  let nextId = 0;
  customElements.define('sbc-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.trigger = this.querySelector('[data-sbc-quick-open]');
      this.template = this.querySelector('[data-sbc-quick-template]');
      if (!this.trigger || !this.template || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.trigger.hidden = false;
      this.querySelector('[data-sbc-quick-fallback]')?.remove();
      this.trigger.addEventListener('click', () => this.open(), options);
      document.addEventListener('sbc:panier-ajout-termine', () => {
        if (!this.busy) return;
        this.setBusy(false);
        this.restoreFocus = false;
        this.dialog?.close();
      }, { ...options, capture: true });
      document.addEventListener('sbc:panier-erreur', (event) => {
        if (!this.busy) return;
        this.setBusy(false);
        this.status.textContent = event.detail?.message || '';
      }, options);
    }
    open() {
      if (!this.dialog) this.createDialog();
      if (this.dialog.open) return;
      this.status.textContent = '';
      this.restoreFocus = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sbc-quick-dialog-open');
      this.dialog.showModal();
      this.dialog.querySelector('[data-sbc-quick-heading]').focus({ preventScroll: true });
    }
    createDialog() {
      const fragment = this.template.content.cloneNode(true);
      this.dialog = fragment.querySelector('dialog');
      const id = `SbcQuickAdd-${++nextId}`;
      this.dialog.id = id;
      const heading = this.dialog.querySelector('[data-sbc-quick-heading]');
      heading.id = `${id}-title`;
      this.dialog.setAttribute('aria-labelledby', heading.id);
      this.trigger.setAttribute('aria-controls', id);
      this.status = this.dialog.querySelector('[data-sbc-quick-status]');
      const options = { signal: this.abort.signal };
      this.dialog.querySelector('[data-sbc-quick-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('sbc-quick-dialog-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.restoreFocus && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-sbc-quick-choice]')) return;
        if (this.busy) { event.preventDefault(); return; }
        this.activeButton = event.submitter || event.target.querySelector('[type="submit"]');
        this.status.textContent = this.dialog.dataset.addingLabel;
        this.setBusy(true);
      }, options);
      document.body.append(fragment);
    }
    setBusy(busy) {
      this.busy = busy;
      this.dialog?.querySelectorAll('[data-sbc-unavailable]').forEach((button) => {
        button.disabled = busy || button.dataset.sbcUnavailable === 'true';
        button.removeAttribute('aria-busy');
      });
      if (busy) this.activeButton?.setAttribute('aria-busy', 'true');
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        document.body.classList.remove('sbc-quick-dialog-open');
        this.dialog.close();
      }
      this.dialog?.remove();
      this.dialog = null;
      this.abort?.abort();
      this.abort = null;
    }
  });
})();
